<mat-tab-group #masterTabGroup mat-stretch-tabs="false" mat-align-tabs="start" class="h-full"
  style="vertical-align: top;" animationDuration="0ms" (selectedTabChange)="onMasterTabChange($event)">
  <mat-tab #myTabGrid label="瀏覽">
    <div class="border-2 border-red-300">
      <app-jkaggrid #myGrid [columnDefs]="srv.columnDefs" [maxHeight]="1000" [minHeight]="300" [defaultHeight]="800"
        [height]="600" (afterGridReadyAg)="afterGridReady($event)" (rowClicked)="agRowClicked($event)"
        (rowSelected)="agRowSelected($event)" (onInsert)="doUIInsert($event)"
        (onDelete)="doUIDelete($event)"></app-jkaggrid>

    </div>
  </mat-tab>

  <mat-tab #myTabDetail label="明細">
    <mat-toolbar>
      <button (click)="doParamTest()" [disabled]="!isBrowse" class="btn-primary">條件值測試</button>
    </mat-toolbar>
    <!-- <app-sysse-tabedit [srv]="srv"></app-sysse-tabedit> -->
  </mat-tab>

  <mat-tab #myTabAdvance label="進階">
    <div class="border-2 min-h-[200px]">[空白]</div>
  </mat-tab>
</mat-tab-group>